import styled from 'styled-components';

import { NoResult } from 'ui/illustrations/NoResult';
import { colors, duration, easing, fontSizes, fontWeights, spacing } from 'ui/theme';
import { isDefined } from 'utils/tsHelpers';

import { useMovableInkCampaignContext } from '../../../contexts/MovableInkCampaignContext';
import { usePanelContext } from '../../../contexts/Panel';
import { useTranslations } from '../../../hooks/useTranslations';

const CtaHeader = styled.div`
  color: ${colors.textPrimary};
  font-size: ${fontSizes.s20};
  font-weight: ${fontWeights.semiBold};
`;

const Cta = styled.div`
  font-size: ${fontSizes.s16};
`;

const EmptyState = styled.div`
  height: 100%;
  align-items: center;
  border-color: ${colors.grey15};
  border-radius: ${spacing.quarter};
  border-style: solid;
  border-width: ${spacing.single};
  bottom: 0;
  color: ${colors.textSecondary};
  display: flex;
  flex-direction: column;
  justify-content: center;
  left: 0;
  padding: ${spacing.plusHalf};
  right: 0;
  row-gap: ${spacing.base};
  top: 0;
  transition: all ${duration.short} ${easing.entrance};
`;

const StyledLabel = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-size: ${fontSizes.s14};
  font-weight: ${fontWeights.regular};
  row-gap: ${spacing.base};
  text-align: center;
  white-space: pre-wrap;
`;

export const testIds = {
  emptyState: 'mi-block-list-empty-state',
  noResults: 'mi-block-list-empty-no-results',
  spinner: 'mi-block-list-empty-spinner',
};

export const BlockTableEmptyState = () => {
  const { t } = useTranslations();
  const { campaignId } = useMovableInkCampaignContext();
  const { panelSearch } = usePanelContext();
  const hasSelectedCampaign = isDefined(campaignId);
  const ctaHeader =
    !hasSelectedCampaign && !panelSearch ? 'header.noResults' : 'header.noMatchingResults';
  const ctaMessage =
    !hasSelectedCampaign && !panelSearch
      ? ''
      : // neither
        (!hasSelectedCampaign && 'caption.tryDifferentKeywords') || // search only
        (!panelSearch && 'caption.tryDifferentCampaign') || // campaign only
        'caption.tryDifferentKeywordsOrCampaign'; // both

  return (
    <EmptyState data-test={testIds.emptyState}>
      <StyledLabel data-test={testIds.noResults}>
        <NoResult />
        <CtaHeader>{t(ctaHeader)}</CtaHeader>
        {ctaMessage ? <Cta>{t(ctaMessage)}</Cta> : null}
      </StyledLabel>
    </EmptyState>
  );
};
